import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createRefetchContainer } from 'react-relay';

// components
import { PdpSharedShippingInfo } from '../PdpSharedShippingInfo/PdpSharedShippingInfo';
import { methodNote, costNote, requestQuoteNotice } from '../messages/pdpDetailsMessages';
import { PdpSharedShippingInfoLink } from '../PdpSharedShippingInfo/PdpSharedShippingInfoLink';

// styles
import styles from './PdpSharedDetail.scss';

// helpers
import get from 'lodash.get';

export class PdpSharedDetailsShippingComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { modalOpen: false, hasLoggedIn: false, address: null };
    }

    render() {
        const {
            item,
            itemId,
            viewer,
            currency,
            user,
            userId,
            shipmentQuote,
            shipment,
            relay,
        } = this.props;

        const leadTime = get(item, 'attributes.leadTime.0.option.urlLabel');
        const quoteRequestStatus = get(viewer, 'relevantShipping.quoteRequestStatus');
        const showQuoteDetails = quoteRequestStatus !== 'requestQuote';

        return (
            <span className={styles.shippingInfoContainer} data-tn="pdp-spec-shipping">
                <PdpSharedShippingInfo
                    currency={currency}
                    shipmentQuote={shipmentQuote}
                    shipment={shipment}
                    leadTime={leadTime}
                    quoteRequestStatus={quoteRequestStatus}
                    renderTooltip
                >
                    <PdpSharedShippingInfoLink
                        currency={currency}
                        shipmentQuote={shipmentQuote}
                        userId={userId}
                        item={item}
                        itemId={itemId}
                        user={user}
                        viewer={viewer}
                        showQuoteDetails={showQuoteDetails}
                        quoteRequestStatus={quoteRequestStatus}
                        onSuccessfulQuoteRequest={relay.refetch}
                    />
                    {!showQuoteDetails && (
                        <p className={styles.requestQuoteNotice}>{requestQuoteNotice}</p>
                    )}
                    {showQuoteDetails && (
                        <div className={styles.notesContainer}>
                            <div className={styles.note}>{methodNote}</div>
                            <div className={styles.note}>{costNote}</div>
                        </div>
                    )}
                </PdpSharedShippingInfo>
            </span>
        );
    }
}

PdpSharedDetailsShippingComponent.propTypes = {
    currency: PropTypes.string,
    userId: PropTypes.string,
    user: PropTypes.object,
    itemId: PropTypes.string,
    viewer: PropTypes.object.isRequired,
    item: PropTypes.object,
    shipmentQuote: PropTypes.object,
    shipment: PropTypes.object,
    relay: PropTypes.object.isRequired,
};

export const PdpSharedDetailShipping = createRefetchContainer(
    PdpSharedDetailsShippingComponent,
    {
        viewer: graphql`
            fragment PdpSharedDetailShipping_viewer on Viewer {
                ...PdpSharedShippingInfoLink_viewer
                relevantShipping(itemId: $itemId, buyerId: $userId) @include(if: $fetchUser) {
                    quoteRequestStatus
                }
            }
        `,
        user: graphql`
            fragment PdpSharedDetailShipping_user on User {
                ...PdpSharedShippingInfoLink_user
            }
        `,
        item: graphql`
            fragment PdpSharedDetailShipping_item on Item {
                ...PdpSharedShippingInfoLink_item
                hasShipmentQuotes
                hasPreQuotedShipping
                itemIsOnHold: isOnHold(buyerId: $userId)
                attributes {
                    leadTime {
                        option {
                            urlLabel
                        }
                    }
                }
            }
        `,
        shipmentQuote: graphql`
            fragment PdpSharedDetailShipping_shipmentQuote on ShipmentQuote {
                subTotalAmount {
                    amount
                }
                isCustom
                isNew
                status
                ...PdpSharedShippingInfoLink_shipmentQuote
                ...PdpSharedShippingInfo_shipmentQuote
            }
        `,
        shipment: graphql`
            fragment PdpSharedDetailShipping_shipment on Shipment {
                ...PdpSharedShippingInfo_shipment
            }
        `,
    },
    graphql`
        query PdpSharedDetailShippingRefetchQuery(
            $userId: String!
            $fetchUser: Boolean!
            $itemId: String!
        ) {
            viewer {
                ...PdpSharedDetailShipping_viewer
                relevantShipping(itemId: $itemId, buyerId: $userId) @include(if: $fetchUser) {
                    shipmentQuote {
                        ...PdpSharedDetailShipping_shipmentQuote
                    }
                    shipment {
                        ...PdpSharedDetailShipping_shipment
                    }
                }
            }
        }
    `
);
